import React from "react";

const Slider = () => {
  return <div></div>;
};

export default Slider;
